<template>
  <div class="about">
    <img
      src="@/assets/images/about_bg.png"
      alt=""
      class="bg img-fluid mb-2 mb-md-5"
    />
    <div class="container content">
      <div class="top row mb-3 mb-md-5">
        <div class="left col-12 col-md-6 pr-5">
          <h2 class="title mb-3 mb-md-5 mt-2 mt-md-0">
            关于我们<span>/about us</span>
          </h2>
          <p class="text">
            中意网是全国首个专门针对文化创意产业的交易而设计的电子商务网站本站以“创意推动中国”为宗旨，涵盖“创意产品采购、创意供应、知识产权交易、产品展示、企业交流”等文化创意产业的供需多元化信息。为文化创意产业供需双方提供一个“权威、开放、安全、畅通”的平台。中意网独创“线上交易+线下认证”的运营模式。线上交易确保交易成本的降低，线下认证交易中心可以保障交易真实性。
          </p>
        </div>
        <div class="right col-12 col-md-6 pl-3 pl-md-5">
          <h2 class="title mb-3 mb-md-5">联系我们<span>/contact us</span></h2>
          <div class="contact-list">
            <div
              class="contact-item"
              v-for="(item, index) in contactList"
              :key="index"
            >
              <img
                :src="require(`@/assets/images/about_icon_${index + 1}.png`)"
                alt=""
                class="icon"
              />
              <span>{{ item }}</span>
            </div>
          </div>
          <p class="location-title">佛山研发和认证中心地址：</p>
          <p class="location">广东省佛山市顺德区裕和路142号金海创意中心</p>
        </div>
      </div>
      <div class="middle rows mb-3 mb-md-5">
        <div
          class="item col-6 col-md-4"
          v-for="(item, index) in shareCodeList"
          :key="index"
        >
          <img
            :src="require(`@/assets/images/about_sharecode_${index + 1}.png`)"
            alt=""
          />
          <p class="mt-3 mb-0 text-center">{{ item }}</p>
        </div>
      </div>
      <div class="bottom">
        <h2 class="title">给我们留言<span>/Leave us a message</span></h2>
        <div class="msg-box">
          <input type="text" placeholder="请输入内容" v-model="content" />
          <button
            class="submit-button px-3 px-md-4"
            @click.prevent.stop="submit"
          >
            提交
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.about {
  padding-bottom: 6rem;
  .title {
    font-size: 1.75rem;
    color: #333333;
    text-align: left;
    // margin-bottom: 2.5rem;
    span {
      font-size: 1.5rem;
      color: #999999;
    }
  }
  .content {
    .top {
      margin-bottom: 4.4rem;
      .left {
        .text {
          text-align: left;
          font-size: 1.13rem;
          color: #666666;
        }
      }
      .right {
        text-align: left;
        .contact-list {
          .contact-item {
            margin-bottom: 1.25rem;
            span {
              vertical-align: middle;
              margin-left: 0.5rem;
              font-size: 1.25rem;
              color: #333333;
            }
          }
        }
        .location-title {
          font-size: 1.38rem;
          color: $acentColor;
        }
        .location {
          font-size: 1.25rem;
          color: #333333;
        }
      }
    }
    .middle {
      display: flex;
      justify-content: space-around;
      margin-bottom: 6.5rem;
      flex-wrap: wrap;
      .item {
        text-align: center;
        p {
          color: #666;
        }
      }
    }
    .bottom {
      .msg-box {
        display: flex;
        height: 3.5rem;
        input[type='text'] {
          flex: 1;
          // height: 100%;
          margin-right: 1.5rem;
          background-color: #e6e6e6;
          font-size: 1.38rem;
          outline: none;
          border: none;
          padding-left: 1.25rem;
          &::placeholder {
            color: #999999;
          }
        }
        .submit-button {
          color: white;
          background-color: $acentColor;
          border: none;
          outline: none;
          font-size: 1.38rem;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>

<script>
import { mapMutations, mapGetters } from 'vuex';
import ApiService from '@/common/api.service';
import qs from 'qs';
export default {
  created() {
    this.setAuth(false);
  },
  data() {
    return {
      shareCodeList: ['小包子小程序', '小包子公众号', '三川田公众号'],
      contactList: [
        '广州市黄埔区科汇金谷四街5号-301',
        '020-37657863',
        'TRF888@333f.com'
      ],
      content: ''
    };
  },
  computed: {
    ...mapGetters(['isLogin', 'token', 'accountName'])
  },
  methods: {
    submit() {
      if (!this.isLogin) {
        this.$router.push('/login');
        return;
      }
      console.log('fuck');

      let data = {
        content: this.content,
        token: this.token,
        accountName: this.accountName
      };
      ApiService.post('/leavingMsgInterface/leavingMsg.htm', qs.stringify(data))
        .then(() => {
          window.alert('提交成功');
        })
        .catch(() => {
          window.alert('提交成功');
        });
    },
    ...mapMutations(['setAuth'])
  }
};
</script>
